import { render, staticRenderFns } from "./devicecomp.vue?vue&type=template&id=636eadb8&scoped=true&"
import script from "./devicecomp.vue?vue&type=script&lang=js&"
export * from "./devicecomp.vue?vue&type=script&lang=js&"
import style0 from "./devicecomp.vue?vue&type=style&index=0&id=636eadb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636eadb8",
  null
  
)

export default component.exports